import { render } from "./Http404.vue?vue&type=template&id=bf153f64&scoped=true"
import script from "./Http404.vue?vue&type=script&lang=js"
export * from "./Http404.vue?vue&type=script&lang=js"

import "./Http404.vue?vue&type=style&index=0&id=bf153f64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf153f64"]])

export default __exports__